import * as TYPES from './type';
export default {
  //授课签到
  [TYPES.SK_YXTASK_LIST](state, { result }) {
    state.SKYXtaskList = result.result
  },
  //预习详情
    [TYPES.SK_YXTASK_DETAILS](state, { result }) {
    state.SKYXtaskDetails = result.result
  },
  //预习测验详情
  [TYPES.SK_YXTASK_LISTDETAIL](state, { result }) {
    state.SKYXtaskListDetail = result.result
  },
  //学生疑惑留言
  [TYPES.SK_YXTASK_STUROOTMESSAGE](state, { result }) {
    state.SKYXtaskStuRootMessage = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/yxTask/mutations.js